/** "Basis and limits": the long honest sentences a screen has to say, ranked below the facts.
 *
 * A collapsed disclosure inside its own panel. **Honesty copy is ranked, never deleted**: every
 * sentence that used to be a paragraph above the controls is still here, one click away, and the
 * title says what it contains. The summary is a real `<summary>`, so it is keyboard-operable and a
 * screen reader hears whether it is open. Closed by default; `open` is for a caller that has a
 * reason to show it first (a refusal, say) and for tests that read the words.
 */

import { CaretRight } from "@phosphor-icons/react";
import type { ReactNode } from "react";

import { Panel } from "./Panel";
import styles from "./Basis.module.css";

export function Basis({
  title = "Basis and limits",
  sub,
  summary,
  open,
  testId,
  column = "1 / 13",
  children,
}: {
  title?: string;
  sub?: string;
  /** The line the closed disclosure shows. */
  summary: string;
  open?: boolean;
  testId?: string;
  column?: string;
  children: ReactNode;
}) {
  return (
    <Panel title={title} sub={sub} column={column}>
      <details className={styles.disclosure} open={open} data-testid={testId}>
        <summary>
          <CaretRight size={16} weight="regular" aria-hidden="true" />
          {summary}
        </summary>
        <div className={styles.body}>{children}</div>
      </details>
    </Panel>
  );
}
